import {
    GET_EMPLOYMENTS_REQUEST,
    GET_EMPLOYMENTS_SUCCESS,
    GET_EMPLOYMENTS_FAILURE,
    ADD_EMPLOYMENT_REQUEST,
    ADD_EMPLOYMENT_SUCCESS,
    ADD_EMPLOYMENT_FAILURE,
    REMOVE_EMPLOYMENT_REQUEST,
    REMOVE_EMPLOYMENT_SUCCESS,
    REMOVE_EMPLOYMENT_FAILURE,
    UPDATE_EMPLOYMENTS_REQUEST,
    UPDATE_EMPLOYMENTS_SUCCESS,
    UPDATE_EMPLOYMENTS_FAILURE,
    UPDATE_EMPLOYMENTUNITS_REQUEST,
    UPDATE_EMPLOYMENTUNITS_SUCCESS,
    UPDATE_EMPLOYMENTUNITS_FAILURE
} from '../constants/employmentActionTypes';

const initialState = {
    employments: [],
    loading: {
        getEmployments: false,
        addEmployment: false,
        removeEmployment: false,
        confirmEmployment: false,
        updateEmployments: false,
        updateEmploymentUnits: false
    },
    error: null,
}

function removeEmployment(state, action) {
    const updatedEmployments = state.employments.filter(employment => {
        return employment.ID !== action.payload.ID;
    });

    return {
        ...state,
        employments: updatedEmployments,
        loading: { ...state.loading, removeEmployment: false },
    };
}

const employmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EMPLOYMENTS_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, getEmployments: true },
                error: null
            };
        case GET_EMPLOYMENTS_SUCCESS:
            return {
                ...state,
                employments: action.payload,
                loading: { ...state.loading, getEmployments: false }
            };
        case GET_EMPLOYMENTS_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, getEmployments: false },
                error: action.payload
            };
        case ADD_EMPLOYMENT_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, addEmployment: true },
                error: null
            };
        case ADD_EMPLOYMENT_SUCCESS:
            return {
                ...state,
                employments: [...state.employments, action.payload.employment],
                loading: { ...state.loading, addEmployment: false }
            };
        case ADD_EMPLOYMENT_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, addEmployment: false },
                error: action.payload
            };
        case REMOVE_EMPLOYMENT_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, removeEmployment: true },
                error: null
            };
        case REMOVE_EMPLOYMENT_SUCCESS:
            return {
                ...state,
                employments: state.employments.filter(employment => employment.ID !== action.payload.ID),
                loading: { ...state.loading, removeEmployment: false }
            };
        case REMOVE_EMPLOYMENT_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, removeEmployment: false },
                error: action.payload
            };
        case UPDATE_EMPLOYMENTS_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, updateEmployments: true },
                error: null
            };
        case UPDATE_EMPLOYMENTS_SUCCESS:
            return {
                ...state,
                employments: action.payload,
                loading: { ...state.loading, updateEmployments: false }
            };
        case UPDATE_EMPLOYMENTS_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, updateEmployments: false },
                error: action.payload
            };
        case UPDATE_EMPLOYMENTUNITS_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, updateEmploymentUnits: true },
                error: null
            };
        case UPDATE_EMPLOYMENTUNITS_SUCCESS:
            return {
                ...state,
                contracts: state.contracts.map(contract => {
                    if (contract.contract.ID === action.payload.ContractID) {
                        const updatedEmployments = contract.employments.map(employmentEntry => {
                            if (employmentEntry.employment.ID === action.payload.ID) {
                                return {
                                    ...employmentEntry,
                                    employment: {
                                        ...employmentEntry.employment,
                                        NumOfUnits: action.payload.NumOfUnits,
                                        NumOfUnitsTeaching: action.payload.NumOfUnitsTeaching
                                    } };
                            }
                            return employmentEntry;
                        });
                        return { ...contract, employments: updatedEmployments };
                    }
                    return contract;
                })
            };
        case UPDATE_EMPLOYMENTUNITS_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, updateEmploymentUnits: false },
                error: action.payload
            };
        default:
            return state;
    }
}

export default employmentReducer;